import { delegate } from '@atomify/core';
import { GTMPush } from '@utilities/gtm';

const GTMTriggerController = () => {
    delegate({
        selector: '[js-hook-gtm-trigger]',
        target: document,
        type: 'click',
        callback: event => {
            const target = (event as any).delegateTarget as HTMLElement;

            const { gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel } = target.dataset;

            const data = {
                event: gtmEvent || '',
                eventCategory: gtmEventCategory || '',
                eventAction: gtmEventAction || '',
                eventLabel: gtmEventLabel || '',
            };

            GTMPush(data);
        },
    });
};

export { GTMTriggerController };
